import { useEffect, useState } from 'react';
import { get } from '../api/client';

/** True when the signed-in person has at least one leaders-survey module. */
export function useSurveyAssignment() {
  const [assigned, setAssigned] = useState(false);

  useEffect(() => {
    let cancelled = false;
    get('/api/leaders-survey/assignment')
      .then((response) => {
        if (cancelled || !response.ok) return;
        setAssigned((response.data?.assignedModules || []).length > 0);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return assigned;
}
